import React from 'react';
import { Routes, Route } from 'react-router-dom';
import SplashScreen from './pages/SplashScreen';
import Login from './pages/Login';
import Verify from './pages/Verify';
import VerifyCode from './pages/VerifyCode';
import VerifyPassword from './pages/VerifyPassword';
import ChangePassword from './pages/ChangePassword';
import Setup from './pages/Setup';
import Story from './pages/Story';
import Home from './pages/Home';
import Account from './pages/Account';
import Profile from './pages/Profile';
import UserProfile from './pages/UserProfile';
import Post from './pages/Post';
import ResetPassword from './pages/ResetPassword';
import VendorLogin from './pages/VendorLogin'
import CreateVendor from './pages/CreateVendor'
import Vendor from './pages/Vendor';
import Event from './pages/Event';
import PostView from './pages/PostView'
import MainPost from './pages/MainPost'
import Accept from './pages/Accept'
import './App.css';
import PostView2 from './pages/PostView2';
import VendorProfile from './pages/VendorProfile';

function App() {
  return (
    <div className="App dark:bg-gray-800 h-screen">
        <Routes>
            <Route path="/splashscreen" element={<SplashScreen />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify" element={<Verify />} />
            <Route path="/verify-code/" element={<VerifyCode />} />
            <Route path="/verify-password/" element={<VerifyPassword />} />
            <Route path="/change-password/" element={<ChangePassword />} />
            <Route path="/setup" element={<Setup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Home />} />
            <Route path="/story" element={<Story />} />
            <Route path="/story/:id" element={<Story />} />
            <Route path="/accept" element={<Accept />} />
            <Route path="/accept/:id" element={<Accept />} />
            <Route path="/post-view" element={<PostView2 />} />
            <Route path="/post/:id" element={<PostView />} />
            <Route path="/post" element={<Post />} />
            <Route path="/main-post" element={<MainPost />} />
            <Route path="/account" element={<Account />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/user-profile" element={<UserProfile />} />
            <Route path="/vendor-login" element={<VendorLogin />} />
            <Route path="/create-vendor" element={<CreateVendor />} />
            <Route path="/vendor" element={<Vendor />} />
            <Route path="/vendor-profile" element={<VendorProfile />} />
            <Route path="/event" element={<Event />} />
         </Routes>
    </div>
  );
}

export default App;
